import request from '@/utils/request'
import qs from 'qs'
const proxyUrl = process.env.Communityapi;
//图片上传
export const photoshowImgUpload = (data) => {
  return request({
    headers: { 'Content-Type': 'multipart/form-data' },
    method: 'post',
    url: proxyUrl + '/photoshow/savePhotoImgs/upload',
    data: data.data
  })
};

//个人影展-查看影展作品详情
export const findPhotoDetail = (data) => {
  return request({
    method: 'post',
    url: proxyUrl + '/photoshow/findPhotoDetail',
    data: qs.stringify(data)
  })
}


// WEBPACK FOOTER //
// ./src/utils/api/Puploadfile.js